import { helpers } from "@vuelidate/validators";

export const technicalValidation = helpers.regex(/^\w+$/);

export const cronExpressionValidation = helpers.regex(/(@(annually|yearly|monthly|weekly|daily|hourly|reboot))|(@every (\d+(ns|us|µs|ms|s|m|h))+)|((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*) ?){5,7})/);

// check if number not zero
export const notZeroValidation = helpers.regex(/^[1-9]/);
